<section class="container" [class.make-payment-background]="isMakePaymentFlow">
  <ng-container
    *ngIf="
      (platformService.isTouch | async) &&
      isMakePaymentFlow &&
      totalPaymentAmount !== null
    "
  >
    <ng-contianer *ngTemplateOutlet="mobileTotalSection"></ng-contianer>
  </ng-container>
  <span
    data-cy="selection-banner-warning-message"
    class="warning-message show-small-devices"
    *ngIf="!!warningMessage"
    ><ion-icon name="alert-circle-outline"></ion-icon> {{ warningMessage }}
  </span>
  <div class="content">
    <div class="right">
      <div class="items-count">
        {{
          (countItemsSelected === 1
            ? 'i18n.payments.itemSelected'
            : 'i18n.payments.itemsSelected'
          ) | translate: { itemsSelected: countItemsSelected }
        }}
      </div>
      <ng-container>
        <div class="separator"></div>
        <ion-button
          data-cy="selection-banner-select-all-button"
          (click)="onSelectAllClick()"
        >
          {{ 'i18n.common.selectAll' | translate }}
        </ion-button>
        <div class="separator"></div>
        <ion-button
          data-cy="selection-banner-deselect-all-button"
          (click)="onDeselectAllClick()"
        >
          {{ 'i18n.common.deselectAll' | translate }}
        </ion-button>
      </ng-container>
    </div>
    <div
      class="banner-gap"
      [class.mobile-download-button]="!isMakePaymentFlow && !totalPaymentAmount"
    >
      <ng-container
        *ngIf="
          (platformService.isTouch | async) === false ||
          !isMakePaymentFlow ||
          totalPaymentAmount === null
        "
      >
        <div
          class="total-payment-amount"
          *ngIf="totalPaymentAmount !== null && showMainAction"
        >
          {{
            'i18n.payments.makePayment.amountDue'
              | translate: { amountDue: totalPaymentAmount | currency }
          }}
        </div>
        <span
          data-cy="selection-banner-warning-message"
          class="warning-message show-big-devices"
          *ngIf="!!warningMessage"
          ><ion-icon name="alert-circle-outline"></ion-icon>
          {{ warningMessage }}
        </span>
        <ion-button
          *ngIf="showMainAction"
          class="pay-button usf-fill-white-button no-border"
          data-cy="selection-banner-pay-button"
          (click)="onMainActionClick()"
        >
          {{ labelMainActionBtn }}
        </ion-button>
        <div
          class="separator"
          *ngIf="showMainAction && isDownloadEnabled"
        ></div>
      </ng-container>
      <ng-container *ngIf="isDownloadEnabled">
        <ion-button
          class="download-button"
          data-cy="selection-banner-download-button"
          (click)="onDownloadClick()"
          [class.non-payment-download-button-width]="!isMakePaymentFlow"
        >
          {{ 'i18n.common.download' | translate }}
        </ion-button>
      </ng-container>
    </div>
  </div>
</section>

<ng-template #mobileTotalSection>
  <div class="total-payment-amount-mobile-container">
    <div
      class="total-payment-amount"
      *ngIf="totalPaymentAmount !== null && showMainAction"
    >
      {{
        'i18n.payments.makePayment.amountDue'
          | translate: { amountDue: totalPaymentAmount | currency }
      }}
    </div>
    <ion-button
      *ngIf="showMainAction"
      class="pay-button usf-fill-white-button no-border"
      data-cy="selection-banner-pay-button"
      (click)="onMainActionClick()"
    >
      {{ labelMainActionBtn }}
    </ion-button>
  </div>
</ng-template>
